"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useAnimate } from "framer-motion";
import { useClickAway, useKeyPressEvent } from "react-use";
import UserSettingsClassificationItem from "./UserSettingsClassificationItem";
import { ApiProfileClassification } from "@/generated/models/ApiProfileClassification";
import { CLASSIFICATIONS } from "@/entities/IProfile";
export default function UserSettingsClassification(t0) {
  const $ = _c(32);
  const {
    selected,
    onSelect
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [iconScope, animateIcon] = useAnimate();
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleOpen = t1;
  let t2;
  if ($[2] !== animateIcon || $[3] !== iconScope || $[4] !== isOpen) {
    t2 = () => {
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: -90
        });
      }
    };
    $[2] = animateIcon;
    $[3] = iconScope;
    $[4] = isOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t2);
  const listRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useClickAway(listRef, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useKeyPressEvent("Escape", t4);
  let t5;
  if ($[8] !== onSelect) {
    t5 = value => {
      onSelect(value);
      setIsOpen(false);
    };
    $[8] = onSelect;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const onClassification = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = Object.values(ApiProfileClassification);
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const classifications = t6;
  const title = CLASSIFICATIONS[selected].title;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <label className="tw-block tw-text-sm tw-font-semibold tw-leading-5 tw-text-iron-300">Profile classification</label>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== title) {
    t8 = <span className="tw-text-iron-50">{title}</span>;
    $[12] = title;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8 || $[15] !== toggleOpen) {
    t9 = <button type="button" onClick={toggleOpen} className="tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-px-3 tw-py-3 tw-text-left tw-text-base tw-font-normal tw-text-iron-50 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-400 hover:tw-ring-iron-600 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400">{t8}</button>;
    $[14] = t8;
    $[15] = toggleOpen;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== iconScope) {
    t11 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3"><svg ref={iconScope} className="tw-h-5 tw-w-5 tw-text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">{t10}</svg></div>;
    $[18] = iconScope;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t9) {
    t12 = <div className="tw-relative tw-mt-2">{t9}{t11}</div>;
    $[20] = t11;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isOpen || $[24] !== onClassification || $[25] !== selected) {
    t13 = isOpen && <motion.div className="tw-absolute tw-right-0 tw-z-10 tw-mt-1 tw-w-full tw-origin-top-right tw-rounded-lg tw-bg-iron-900 tw-shadow-xl tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-absolute tw-z-10 tw-mt-1 tw-w-full tw-max-w-full tw-overflow-hidden tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-flow-root tw-max-h-[calc(280px+_-5vh)] tw-overflow-y-auto tw-overflow-x-hidden tw-py-1 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 desktop-hover:hover:tw-scrollbar-thumb-iron-300"><ul className="tw-mx-0 tw-mb-0 tw-flex tw-list-none tw-flex-col tw-px-2">{classifications.map(classification => <UserSettingsClassificationItem key={classification} classification={classification} selected={selected} onClassification={onClassification} />)}</ul></div></div></motion.div>;
    $[23] = isOpen;
    $[24] = onClassification;
    $[25] = selected;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = <AnimatePresence mode="wait" initial={false}>{t13}</AnimatePresence>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <div className="tw-relative tw-max-w-full" ref={listRef}>{t7}{t12}{t14}</div>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}